<template>
  <div class="tree-style server-manage">
  <Modal title="搜索条件" v-model="searchConditionModal" width="600">
      <Form label-position="top">
        <FormItem label="条件">
          <CheckboxGroup v-model="condition" @on-change="conditionChange">
            <Checkbox label="主机名"></Checkbox>
            <Checkbox label="操作系统"></Checkbox>
            <Checkbox label="服务商"></Checkbox>
            <Checkbox label="主机ID"></Checkbox>
            <Checkbox label="别名"></Checkbox>
            <Checkbox label="私有IP"></Checkbox>
            <Checkbox label="公网IP"></Checkbox>
            <Checkbox label="地域"></Checkbox>
          </CheckboxGroup>
        </FormItem>
        <FormItem :label="key" v-for="(data, key, idx) in conditionObjects" :key="idx">
          <Input v-if="key === '主机ID' || key === '别名' || key === '地域'" v-model="data.value" placeholder="请输入关键词" style="width: 560px">
            <Select v-model="data.rule" slot="prepend" style="width: 60px" placeholder="匹配规则">
              <Option value="contain">包含</Option>
              <!-- <Option value="no_equal">不包含</Option> -->
            </Select>
          </Input>
          <Select v-if="key === '操作系统'" v-model="data.rule" style="width: 80px;">
            <Option value="contain">等于</Option>
          </Select>
          <Select v-if="key !== '主机ID' && key !== '别名' && key !== '地域' && key !== '操作系统'" v-model="data.rule" style="width: 80px;" @on-change="ruleChange(key, data.rule)">
            <Option value="equal">等于</Option>
            <Option value="contain">包含</Option>
          </Select>
          <Input v-if="key !== '主机ID' && key !== '别名' && key !== '地域' && key !== '操作系统' && data.rule === 'contain'" v-model="data.value" placeholder="请填写名称" style="width: 480px"/>
          <Select v-if="key === '主机名' && data.rule === 'equal'" v-model="data.value" style="width: 480px" filterable multiple>
            <Option v-for="(item, index) in allServers" :value="item" :key="index">{{ item }}</Option>
          </Select>
           <Select v-if="key === '私有IP' && data.rule === 'equal'" v-model="data.value" style="width: 480px" filterable multiple>
            <Option v-for="(item, index) in allInnerIp" :value="item" :key="index">{{ item }}</Option>
          </Select>
           <Select v-if="key === '公网IP' && data.rule === 'equal'" v-model="data.value" style="width: 480px" filterable multiple>
            <Option v-for="(item, index) in allPublicIp" :value="item" :key="index">{{ item }}</Option>
          </Select>
          <Select v-if="key === '服务商' && data.rule === 'equal'" v-model="data.value" style="width: 480px" filterable multiple>
            <Option v-for="item in allSupportList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
          <Select v-if="key === '操作系统'" v-model="data.value" style="width: 480px" filterable clearable>
            <Option v-for="item in osList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button style="float: left" @click="searchConditionClear">清空</Button>
        <!-- <Poptip placement="top" width="200">
          <Button type="text" style="color: #2d8cf0">另存为</Button>
          <div class="api" slot="content">
            <div style="padding-bottom: 5px">保存收藏条件：</div>
            <Input v-model="containName" size="small" placeholder="请填写名称"/>
            <div style="float: right; margin-top:5px;">
              <Button type="primary" @click="conditionSave" size="small">保存</Button>
            </div>
          </div>
        </Poptip> -->
        <!-- <Button type="text" style="color: #2d8cf0" @click="conditionSave" :disabled="this.containName ? false : true">保存</Button> -->
        <Button type="primary" style="margin-left:5px;"  @click="search">查询</Button>
      </div>
    </Modal>
    <Modal title="显示列" v-model="tableColModal">
      <Checkbox-group v-model="col">
        <Checkbox :label="item.key" v-for="item in tableColumnList" :key="item.key" v-if="item.key">{{ item.title }}</Checkbox>
      </Checkbox-group>
      <div slot="footer">
        <Button type="primary" :loading="saveShowColConfiging" style="margin-right: 8px" icon="md-checkmark" @click="saveShowColConfig">保存</Button>
        <Button @click="tableColModal = false">取消</Button>
      </div>
    </Modal>
    <Drawer
      title="扫描主机"
      v-model="scanModal"
      width="600"
      :mask-closable="false"
      @on-close="drawerClose">
      <Tabs v-model="defaultScanIndex" @on-click="handleTabClick">
          <TabPane label="扫描网段IP" name="scanIP">
            <i-form ref="scanForm" :model="scanForm"  :rules="scanRule" :label-width="75" label-position="right">
              <form-item label="扫描网段" prop="network" class="mob-align-right">
                <i-input v-model="scanForm.network" placeholder="请填写扫描IP网段 例如192.168.1.0/24 或者 单个主机IP " style="max-width: 350px;margin: 0 6px 0px 0;"></i-input>
                <Button type="primary" @click="scanSubmit('scanForm')" :loading="scanServerLoading" class="scanBtn">开始扫描</Button>
              </form-item>
              <form-item :label-width="0">
                 <Alert type="error">请在扫描过程完全结束后再选中主机导入</Alert>
                  <Table
                    ref="selectionScan"
                    size="small"
                    height="400"
                    @on-selection-change="selectChangeScan"
                    :columns="columnsScan"
                    :data="tableDataScan"
                    :loading="table_loadingScan"
                  ></Table>
                  <div style="margin: 10px 0; overflow: hidden;">
                    <div>
                      <span style="float: left;">已选择 {{ countScanSel }} 条</span>
                      <span style="float: right;">共 {{ countScan }} 条</span>
                    </div>
                  </div>
              </form-item>
              <form-item :label-width="0">
                <Button type="primary" @click="scanConfirmSubmit('scanForm')" :disabled="scanServerOkDisabled" :loading="scanServerOkLoading">导入选中主机</Button>
                <Button style="margin-left: 8px" @click="scanModal = false">取消</Button>
              </form-item>
            </i-form>
          </TabPane>
          <TabPane label="扫描主机名" name="scanHostName">
            <Form :model="scanHostNameForm" ref="scanHostNameForm" :label-width="0" label-position="right">
              <Alert type="error">要先把扫描到的网段ip 绑定凭证，才可以执行获取主机名</Alert>
              <form-item :label-width="0">
                  <Table
                    ref="selectionScanHostName"
                    size="small"
                    height="400"
                    @on-selection-change="selectChangeScanHostName"
                    :columns="columnsScanHostName"
                    :data="tableDataScanHostName"
                    :loading="table_loadingScanHostName"
                  ></Table>
                  <div style="margin: 10px 0; overflow: hidden;">
                    <div>
                      <span style="float: left;">已选择 {{ countScanHostNameSel }} 条</span>
                      <span style="float: right;">共 {{ countScanHostName }} 条</span>
                    </div>
                  </div>
              </form-item>
              <FormItem>
                <Button type="primary" @click="scanHostNameSubmit" :loading="scanHostNameLoading">获取主机名</Button>
                <Button style="margin-left: 8px" @click="scanModal = false">取消</Button>
              </FormItem>
            </Form>
          </TabPane>
      </Tabs>
    </Drawer>
    <Drawer
      title="收集主机"
      v-model="collectModal"
      width="500"
      :mask-closable="false">
      <Form :model="collectForm" ref="collectForm" :rules="collectRule" :label-width="75" label-position="right">
        <FormItem label="服务商">
          <Select v-model="collectForm.support" style="width:100%" @on-change="supportChange">
            <Option v-for="item in allSupportList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="所在地域">
          <Select filterable v-model="collectForm.region" style="width:100%">
            <Option v-for="item in regionList" :value="item.value" :key="item.value">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="collectSubmit" :loading="collectServerLoading">收集</Button>
          <Button style="margin-left: 8px" @click="collectModal = false">取消</Button>
        </FormItem>
      </Form>
    </Drawer>
    <Drawer
      :title="serverChangeModalTitle"
      v-model="serverChangeModal"
      width="702"
      :mask-closable="false"
      @on-close="serverChangeModalClose">
      <Form :model="serverForm" ref="serverForm" :rules="serverFormRule" inline :label-width="75" label-position="right">
        <FormItem label="主机名" prop="hostname">
          <Input v-model="serverForm.hostname" style="min-width: 250px" />
        </FormItem>
        <FormItem label="主机ID" prop="server_id">
          <Input v-model="serverForm.server_id" style="min-width: 250px" />
        </FormItem>
        <FormItem label="别名" prop="name">
          <Input v-model="serverForm.name" style="min-width: 250px" />
        </FormItem>
        <FormItem label="私有IP">
          <Input v-model="serverForm.inner_ip" style="min-width: 250px" />
        </FormItem>
        <FormItem label="公网IP">
          <Input v-model="serverForm.public_ip" style="min-width: 250px" />
        </FormItem>
        <FormItem label="操作系统">
          <Select v-model="serverForm.os" style="min-width:250px" @on-change="onSelectOs">
            <Option v-for="item in osList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem label="服务商">
          <Select v-model="serverForm.support" style="min-width:250px">
            <Option v-for="item in allSupportList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="所属项目">
          <Select v-model="serverForm.tenant_id" style="min-width:250px">
            <Option v-for="item in tenantList" :value="item.key" :key="item.key">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem label="地域">
          <Input v-model="serverForm.region" style="min-width: 250px" />
        </FormItem>
        <FormItem label="凭证">
          <Select v-model="serverForm.certificate" style="min-width:250px" multiple>
            <Option v-for="item in allCertificateList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="管理员">
          <Input v-model="serverForm.manager" style="min-width: 250px" />
        </FormItem>
        <FormItem label="Winrm端口" v-show="winrmVisible">
          <Input v-model="serverForm.winrm_port" style="min-width: 250px" />
        </FormItem>
        <row>
        <FormItem label="其他信息" style="width: 100%">
          <Input type="textarea" v-model="serverForm.server_info" placeholder="格式（字典）：{key: value, key2: value2}" />
        </FormItem>
        </row>
        <FormItem label="备注" style="width: 100%">
          <Input type="textarea" v-model="serverForm.remark" />
        </FormItem>
        <FormItem>
          <Button type="primary" @click="changeServerSubmit">提交</Button>
          <Button style="margin-left: 8px" @click="serverChangeModalClose">取消</Button>
        </FormItem>
      </Form>
    </Drawer>
    <Drawer
      :title="editServerModalTitle"
      v-model="editServerModal"
      width="900"
      :mask-closable="false"
      @on-close="editServerModalCancel">
      <transfer
        :data="no_select_server"
        :target-keys="editServerForm.server"
        :list-style="listStyle"
        @on-change="editServerChange"
        filterable></transfer>
      <Row :style="{marginTop: '20px'}">
        <Button type="primary" @click="editServerForGroupSubmit">提交</Button>
        <Button style="margin-left: 8px" @click="editServerModal = false">取消</Button>
      </Row>
    </Drawer>

    <Row :style="{backgroundColor: '#fff', padding: '10px 10px', borderRadius: '3px'}">
      <!--<a class="tree-menu">选择主机</a>-->

      <Col v-bind:span="serverGroupSpan">
        <Button @click="ServerGroupShowBtn(false)" v-show="ServerGroupIsShow" type="primary" size="small" :style="{float: 'right', marginRight: '20px'}" class="mob-hidden">
          <Icon type="ios-arrow-back" />
        </Button>
        <Button @click="ServerGroupShowBtn(true)" v-show="!ServerGroupIsShow" type="primary" size="small" :style="{float: 'right', marginRight: '10px'}">
          <Icon type="ios-arrow-forward" />
        </Button>
        <ul v-show="ServerGroupIsShow" id="serverGroupZTree" class="ztree"></ul>
      </Col>
      <div id="rMenu" style="z-index: 1999;">
        <a href="#" class="list-group-item" @click="editServerBtn">绑定主机</a>
        <a href="#" class="list-group-item" @click="expand">展开下一级</a>
        <a href="#" class="list-group-item" @click="expandSon">展开所有子节点</a>
        <a href="#" class="list-group-item" @click="collapse">折叠子节点</a>
        <a href="#" class="list-group-item" @click="openAll">全部展开</a>
        <a href="#" class="list-group-item" @click="collapseAll">全部折叠</a>
      </div>
      <Col v-bind:span="serverTableSpan">
        <!-- <Row>
          <Col>
          <Form :model="searchForm" ref="searchForm" inline :label-width="60">
            <FormItem label="主机名">
              <Input v-model="searchForm.hostname" style="min-width: 170px" />
            </FormItem>
            <FormItem label="主机ID">
              <Input v-model="searchForm.server_id" style="min-width: 170px" />
            </FormItem>
            <FormItem label="别名">
              <Input v-model="searchForm.name" style="min-width: 170px" />
            </FormItem>
            <FormItem label="私有IP">
              <Input v-model="searchForm.inner_ip" style="min-width: 170px" />
            </FormItem>
            <FormItem label="公网IP">
              <Input v-model="searchForm.public_ip" style="min-width: 170px" />
            </FormItem>
            <FormItem label="服务商">
              <Select v-model="searchForm.support" style="min-width:170px" clearable>
                <Option v-for="item in allSupportList" :value="item.id" :key="item.id">{{ item.name }}</Option>
              </Select>
            </FormItem>
            <FormItem label="地域">
              <Input v-model="searchForm.region" style="min-width: 170px" />
            </FormItem>
            <FormItem label="操作系统">
              <Select v-model="searchForm.os" style="min-width:170px" clearable placeholder="">
                <Option v-for="item in osList" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
            <FormItem label="其他信息">
              <Input v-model="searchForm.server_info" style="min-width: 170px" />
            </FormItem>
            <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getServers()">搜索</Button>
              <Button style="margin-left: 8px" @click="searchReset">重置</Button>
            </FormItem>
          </Form>
          </Col>
        </Row> -->
        <row>
          <div style="margin-bottom: 10px;float: right">
            <Tag v-for="(data, key, idx) in conditionObjects" :key="idx" :name="key" closable @on-close="handleClose" @click.native="tagClick">{{ data.rule === 'no_equal' ? '非 ' : '' }}{{ key }}: {{ dealShowName(data.value, key, data.rule) }}</Tag>
            <!-- <Button icon="ios-add" type="info"  @click="handleAdd" >添加筛选</Button> -->
            <!-- <Tooltip content="自动刷新" placement="bottom">
              <i-switch v-model="monitorModal" style="margin-right: 15px" size="large" @on-change="controlMonitorTimer">
                <span slot="open">自动</span>
                <span slot="close">关闭</span>
              </i-switch>
            </Tooltip> -->
            <Tooltip content="筛选" style="margin-right:5px;">
              <Button icon="ios-funnel" @click="searchConditionModifyOpen"></Button>
            </Tooltip>
            <Button type="primary" style="margin-left:5px;margin-right:5px;"  @click="search">查询</Button>
             <Button style="margin-right:5px;" type="info" @click="showColConfig">显示列</Button>
            <ButtonGroup style="margin-right:5px;">
              <Button type="primary" v-show="isServerAdd" @click="serverChangeModal = true; serverChangeModalTitle = '添加主机'">添加主机</Button>
              <Button type="primary" @click="collectModal = true">收集主机</Button>
              <Button type="primary" @click="handleScan">扫描主机</Button>
            </ButtonGroup>
            <!-- <Button style="margin: 0 10px 10px" v-show="isServerEdit" type="warning" icon="ios-create-outline" @click="serverChangeModifyModalOpen">编辑</Button> -->
            <Button style="margin-right:5px;" v-show="isServerDelete" type="error" @click="serverRemove">批量删除</Button>
            <Checkbox style="margin-top: 10px;float: right" v-model="deleteFlag" @on-change="showDeleteChange">显示已删除的主机</Checkbox>
          </div>
        </row>
        <Row>
          <Table
            ref="table"
            size="small"
            :columns="columns"
            @on-selection-change="selectChange"
            @on-sort-change="sortChange"
            :data="tableData"
            :loading="table_loading"
            class="xl-remove-table-fixed"
          ></Table>
          <div style="margin: 10px 0; overflow: hidden;">
            <div style="float: right;">
              <page :total="count" :current="page" :page-size="size" @on-change="getServers"
                    show-total show-sizer show-elevator transfer
                    :page-size-opts="[10, 18, 30]"
                    @on-page-size-change="pageSizeChange"></page>
            </div>
          </div>
        </Row>
      </Col>
    </Row>
  </div>
</template>
<script>
import { getOpsCenterServerGroup, changeOpsCenterServerGroup, deleteOpsCenterServerGroup,
  getOpsCenterAllSupport, changeOpsCenterServer, getOpsCenterServer, getOpsCenterAllServer,
  getOpsCenterAllCertificate, getRegion, collectServer, scanServer, getUserHostPerm, getConnectId,
  scanHostName, scanServerOk, getOpsCenterAllScanServer, getAllScanTmp, getServerTableCol,
  postServerTableCol } from '@/api/opscenter'

// import { getConnectId } from '@/api/springboard'
import { ClientIdentifier } from '@/libs/clientIdentifier'
import config from '@/config'
import Vue from 'vue'
import {getAllTenants} from '@/api/user'
// import { getBaseMonitorOne } from '@/api/monitor'

const guacamoleUrl = config.guacamoleUrl

export default {
  name: 'server-manage',
  data () {
    return {
      tenantList: [],
      deleteFlag: false,
      allServersRemote: [],
      allInnerIpRemote: [],
      allPublicIpRemote: [],
      loadingServer: false,
      loadingInnerIp: false,
      loadingPublicIp: false,
      allServers: [],
      allInnerIp: [],
      allPublicIp: [],
      searchConditionModal: false,
      currentSearchCondition: '',
      searchConditions: [],
      condition: [],
      conditionObjects: {},
      containName: '',
      conditionValue: [],
      winrmVisible: true,
      polling: null,
      columnsScan: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        // {
        //   minWidth: 100,
        //   title: '主机名',
        //   tooltip: true,
        //   key: 'hostname',
        //   align: 'center'
        // },
        {
          minWidth: 100,
          title: '设备类型',
          align: 'center',
          key: 'os',
          render: (h, params) => {
            let k = { 0: 'Linux', 1: 'Windows', 2: '网络设备', 4: '未知', 9: '获取中' }
            if (params.row.os === 0 || params.row.os === 1 || params.row.os === 2 || params.row.os === 4 || params.row.os === 9) {
              const color = params.row.os === 9 ? 'default' : params.row.os === 4 ? 'warning' : 'success'
              // const text = row.status === 0 ? '断开' : row.status === 1 ? '运行' : '未知'
              return h('Tag', {
                props: {
                  type: 'dot',
                  color: color
                }
              }, k[params.row.os])
            } else {
              return ''
            }
          }
        },
        {
          minWidth: 130,
          title: '私有IP',
          align: 'center',
          key: 'inner_ip'
        }
      ],
      countScanSel: 0,
      countScan: 0,
      tableDataScan: [],
      tableDataScanSel: [],
      table_loadingScan: false,
      columnsScanHostName: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          minWidth: 130,
          title: '私有IP',
          align: 'center',
          key: 'inner_ip'
        },
        {
          minWidth: 100,
          title: '操作系统',
          align: 'center',
          key: 'os',
          render: (h, params) => {
            let k = { 0: 'Linux', 1: 'Windows' }
            if (params.row.os === 0 || params.row.os === 1) {
              return h('div', k[params.row.os])
            } else {
              return ''
            }
          }
        },
        {
          minWidth: 160,
          title: '凭证',
          align: 'center',
          key: 'certificate',
          render: (h, params) => {
            if (params.row.certificate) {
              // 取凭证数组里面 is_admin 是true的名字
              let cerAdmin = params.row.certificate.filter(item => item.is_admin === true)
              if (cerAdmin.length > 0) {
                return h('div', cerAdmin[0].name)
              }
            } else {
              return ''
            }
          }
        }
      ],
      countScanHostNameSel: 0,
      countScanHostName: 0,
      tableDataScanHostName: [],
      tableDataScanHostNameSel: [],
      table_loadingScanHostName: false,
      defaultScanIndex: 'scanIP',
      isServerAdd: false,
      isServerEdit: false,
      isServerDelete: false,
      isServerView: false,
      ServerGroupIsShow: true,
      serverGroupSpan: 5,
      serverTableSpan: 19,
      screenWidth: document.body.clientWidth,
      osList: [
        {
          value: 0,
          label: 'Linux'
        },
        {
          value: 1,
          label: 'Windows'
        }
      ],
      searchForm: {
        id__in: '',
        hostname: '',
        server_id: '',
        name: '',
        inner_ip: '',
        public_ip: '',
        support: '',
        region: '',
        os: '',
        server_info: '',
        ordering: '',
        rules: null
      },
      count: 0,
      page: 1,
      size: 18,
      selectRow: '',
      systemUsersAll: [],
      systemUsersSel: '',
      systemUserKeySel: '',
      conProtocolType: '',
      conHostOs: '',
      userPermDetail: [],
      defaultIp: 'public',
      defaultSelIp: null,
      monitorModal: false,
      timer: null,
      monitorParams: {},
      columnsMonitor: [
        {
          type: 'selection',
          width: 60,
          fixed: 'left',
          align: 'center'
        },
        {
          minWidth: 160,
          title: '主机名',
          tooltip: true,
          fixed: 'left',
          key: 'hostname',
          sortable: 'custom',
          align: 'center',
          render: (h, params) => {
            let hostname = params.row.hostname
            if (!hostname) {
              hostname = '未识别'
            }
            return h('router-link', {
              props: {
                to: {
                  name: 'server_detail',
                  query: { id: params.row.id }
                }
              }
            }, hostname)
          }
        },

        {
          minWidth: 130,
          title: '私有IP',
          align: 'center',
          sortable: 'custom',
          key: 'inner_ip'
        },
        {
          minWidth: 120,
          title: '公网IP',
          align: 'center',
          sortable: 'custom',
          key: 'public_ip'
        },
        {
          minWidth: 120,
          title: '状态',
          align: 'center',
          sortable: 'custom',
          key: 'status',
          render: (h, params) => {
            const row = params.row
            const color = row.troop_status ? 'success' : 'error'
            const text = row.troop_status ? '运行' : '断开'

            return h('Badge', {
              props: {
                text: text,
                status: color
              }
            })
          }
        },
        {
          minWidth: 120,
          title: '已安装Agent',
          key: 'troop_status',
          align: 'center',
          render: (h, params) => {
            const row = params.row
            const text = row.troop_status ? '是' : '否'

            return h('span', {
              style: {
                color: row.troop_status ? '#19be6b' : ''
              }
            }, text)
          }
        },
        {
          minWidth: 130,
          title: 'CPU使用率',
          align: 'center',
          sortable: 'custom',
          key: 'cpu_usage',
          render: (h, params) => {
            if (params.row.cpu_usage || params.row.cpu_usage === 0) {
              let tagType = 'success'
              if (params.row.cpu_usage > 90) {
                tagType = 'error'
              } else if (params.row.cpu_usage > 70) {
                tagType = 'warning'
              }
              return h('div', {
                class: 'ivu-tag ivu-tag-' + tagType + ' ivu-tag-checked'
              }, params.row.cpu_usage)
            } else {
              return h('div', {
                style: {
                  color: '#999'
                }
              }, '无数据')
            }
          }
        },
        {
          minWidth: 130,
          title: '内存使用率',
          align: 'center',
          sortable: 'custom',
          key: 'memory_usage',
          render: (h, params) => {
            if (params.row.memory_usage || params.row.memory_usage === 0) {
              let tagType = 'success'
              if (params.row.memory_usage > 90) {
                tagType = 'error'
              } else if (params.row.memory_usage > 70) {
                tagType = 'warning'
              }
              return h('div', {
                class: 'ivu-tag ivu-tag-' + tagType + ' ivu-tag-checked'
              }, params.row.memory_usage)
            } else {
              return h('div', {
                style: {
                  color: '#999'
                }
              }, '无数据')
            }
          }
        },
        {
          minWidth: 130,
          title: '磁盘使用率',
          sortable: 'custom',
          align: 'center',
          key: 'disk_usage',
          render: (h, params) => {
            if (params.row.disk_usage || params.row.disk_usage === 0) {
              let tagType = 'success'
              if (params.row.disk_usage > 90) {
                tagType = 'error'
              } else if (params.row.disk_usage > 70) {
                tagType = 'warning'
              }
              return h('div', {
                class: 'ivu-tag ivu-tag-' + tagType + ' ivu-tag-checked'
              }, params.row.disk_usage)
            } else {
              return h('div', {
                style: {
                  color: '#999'
                }
              }, '无数据')
            }
          }
        }
      ],
      tableColumnList: {
        selection: {
          type: 'selection',
          width: 60,
          fixed: 'left',
          align: 'center'
        },
        hostname: {
          minWidth: 160,
          title: '主机名',
          tooltip: true,
          fixed: 'left',
          key: 'hostname',
          sortable: 'custom',
          align: 'center',
          render: (h, params) => {
            let hostname = params.row.hostname
            if (!hostname) {
              hostname = '未识别'
            }
            return h('router-link', {
              props: {
                to: {
                  name: 'server_detail',
                  query: { id: params.row.id }
                }
              }
            }, hostname)
          }
        },
        server_id: {
          minWidth: 140,
          title: '主机ID',
          tooltip: true,
          align: 'center',
          sortable: 'custom',
          key: 'server_id'
        },
        name: {
          minWidth: 100,
          title: '别名',
          tooltip: true,
          align: 'center',
          sortable: 'custom',
          key: 'name'
        },
        os: {
          minWidth: 110,
          title: '操作系统',
          align: 'center',
          sortable: 'custom',
          key: 'os',
          render: (h, params) => {
            let k = { 0: 'Linux', 1: 'Windows' }
            if (params.row.os === 0 || params.row.os === 1) {
              return h('div', k[params.row.os])
            } else {
              return ''
            }
          }
        },
        status: {
          minWidth: 120,
          title: '状态',
          align: 'center',
          key: 'status',
          sortable: 'custom',
          render: (h, params) => {
            const row = params.row
            const color = row.status === 0 || row.status === -1 ? 'error' : row.status === 1 ? 'success' : 'warning'
            const text = row.status === 0 || row.status === -1 ? '断开' : row.status === 1 ? '运行' : '未知'

            return h('Badge', {
              props: {
                text: text,
                status: color
              }
            })
          }
        },
        troop_status: {
          minWidth: 120,
          title: '已安装Agent',
          key: 'troop_status',
          align: 'center',
          render: (h, params) => {
            const row = params.row
            const text = row.troop_status ? '是' : '否'

            return h('span', {
              style: {
                color: row.troop_status ? '#19be6b' : ''
              }
            }, text)
          }
        },
        inner_ip: {
          minWidth: 130,
          title: '私有IP',
          align: 'center',
          sortable: 'custom',
          key: 'inner_ip'
        },
        public_ip: {
          minWidth: 120,
          title: '公网IP',
          align: 'center',
          sortable: 'custom',
          key: 'public_ip'
        },
        expire_date: {
          minWidth: 110,
          title: '到期时间',
          align: 'center',
          sortable: 'custom',
          key: 'expire_date',
          render: (h, params) => {
            let color = 'green'
            if (params.row.expire_date) {
              let lastTime = this.daysBetween(params.row.expire_date, 'now')
              if (lastTime <= 7) {
                color = 'red'
              }
              return h('span', { style: { color: color } }, params.row.expire_date)
            } else {
              return h('span', { style: { color: '#999' } }, '无')
            }
          }
        },
        cpu_usage: {
          minWidth: 130,
          title: 'CPU使用率',
          align: 'center',
          sortable: 'custom',
          key: 'cpu_usage',
          render: (h, params) => {
            if (params.row.cpu_usage || params.row.cpu_usage === 0) {
              let tagType = 'success'
              if (params.row.cpu_usage > 90) {
                tagType = 'error'
              } else if (params.row.cpu_usage > 70) {
                tagType = 'warning'
              }
              return h('div', {
                class: 'ivu-tag ivu-tag-' + tagType + ' ivu-tag-checked'
              }, params.row.cpu_usage)
            } else {
              return h('div', {
                style: {
                  color: '#999'
                }
              }, '无数据')
            }
          }
        },
        memory_usage: {
          minWidth: 130,
          title: '内存使用率',
          align: 'center',
          sortable: 'custom',
          key: 'memory_usage',
          render: (h, params) => {
            if (params.row.memory_usage || params.row.memory_usage === 0) {
              let tagType = 'success'
              if (params.row.memory_usage > 90) {
                tagType = 'error'
              } else if (params.row.memory_usage > 70) {
                tagType = 'warning'
              }
              return h('div', {
                class: 'ivu-tag ivu-tag-' + tagType + ' ivu-tag-checked'
              }, params.row.memory_usage)
            } else {
              return h('div', {
                style: {
                  color: '#999'
                }
              }, '无数据')
            }
          }
        },
        disk_usage: {
          minWidth: 130,
          title: '磁盘使用率',
          align: 'center',
          sortable: 'custom',
          key: 'disk_usage',
          render: (h, params) => {
            if (params.row.disk_usage || params.row.disk_usage === 0) {
              let tagType = 'success'
              if (params.row.disk_usage > 90) {
                tagType = 'error'
              } else if (params.row.disk_usage > 70) {
                tagType = 'warning'
              }
              return h('div', {
                class: 'ivu-tag ivu-tag-' + tagType + ' ivu-tag-checked'
              }, params.row.disk_usage)
            } else {
              return h('div', {
                style: {
                  color: '#999'
                }
              }, '无数据')
            }
          }
        },
        support_name: {
          minWidth: 160,
          title: '服务商',
          align: 'center',
          tooltip: true,
          key: 'support_name'
        },
        manager: {
          minWidth: 100,
          title: '管理员',
          align: 'center',
          key: 'manager'
        },
        certificate: {
          minWidth: 160,
          title: '凭证',
          align: 'center',
          key: 'certificate',
          render: (h, params) => {
            if (params.row.certificate) {
              // 取凭证数组里面 is_admin 是true的名字
              let cerAdmin = params.row.certificate.filter(item => item.is_admin === true)
              if (cerAdmin.length > 0) {
                return h('div', cerAdmin[0].name)
              }
            } else {
              return ''
            }
          }
        },
        action: {
          minWidth: 80,
          title: '操作',
          align: 'center',
          fixed: 'right',
          key: '',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'warning',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.serverChangeModifyModalOpen(params)
                  }
                }
              }, '编辑')
            ])
          }
        }
      },
      columns: [],
      tableData: [],
      table_loading: false,
      newCount: 1,
      zTreeSetting: {
        view: {
          addHoverDom: this.addHoverDom,
          removeHoverDom: this.removeHoverDom,
          selectedMulti: false,
          showTitle: false
        },
        edit: {
          enable: true,
          editNameSelectAll: true,
          showRemoveBtn: true,
          showRenameBtn: true
        },
        data: {
          simpleData: {
            enable: true,
            idKey: 'id',
            pIdKey: 'parent_id',
            rootPId: 0
          },
          key: {
            title: '22222'
          }
        },
        check: {
          enable: false
        },
        callback: {
          onClick: this.zTreeOnClick,
          onRightClick: this.OnRightClick,
          beforeDrag: this.beforeDrag,
          beforeRemove: this.beforeRemove,
          beforeRename: this.beforeRename,
          onRemove: this.onRemove,
          onRename: this.onRename
        }
      },
      zTree: '',
      zNodes: [{ 'id': 0, 'parent_id': 0, 'name': '所有主机', 'open': 'true' }],
      editServerModal: false,
      editServerModalTitle: '绑定主机',
      no_select_server: [],
      editServerForm: {
        id: 0,
        name: '',
        server: [],
        parent_id: 0
      },
      listStyle: {
        width: '400px',
        height: '400px'
      },
      serverChangeModal: false,
      serverForm: {
        id: 0,
        hostname: '',
        server_id: '',
        name: '',
        inner_ip: '',
        public_ip: '',
        os: 0,
        support: '',
        region: '',
        certificate: [],
        manager: '',
        server_info: '',
        remark: '',
        winrm_port: null,
        tenant_id: null
      },
      serverFormRule: {
        hostname: [
          { required: true, message: '主机名不能为空', trigger: 'blur' }
        ]
        // server_id: [
        //   { required: true, message: '实例ID不能为空', trigger: 'blur' }
        // ],
        // name: [
        //   { required: true, message: '实例名称不能为空', trigger: 'blur' }
        // ]
      },
      serverChangeModalTitle: '添加主机',
      allSupportList: [],
      allCertificateList: [],
      collectForm: {
        support: '',
        region: ''
      },
      scanForm: {
        network: '',
        hosts: []
      },
      scanHostNameForm: {
        hosts: []
      },
      collectRule: {
        support: [
          { require: true, message: '服务商不能为空', trigger: 'blur' }
        ]
      },
      scanRule: {
        // network: [
        //   { require: true, message: '扫描网段/ip不能为空', trigger: 'blur' }
        // ]
      },
      collectServerLoading: false,
      scanServerLoading: false,
      scanServerOkLoading: false,
      scanServerOkDisabled: true,
      scanHostNameLoading: false,
      allRegionList: [],
      regionList: [],
      collectModal: false,
      scanModal: false,
      scanHostNameModal: false,
      tableColModal: false,
      col: [],
      saveShowColConfiging: false
    }
  },
  mounted: function () {
    this.initOperatePerm()
    this.getServers()
    this.getServerGroup()
    this.getAllServers()
    this.getAllSupport()
    this.getAllCertificate()
    this.getRegionList()
    this.getTenants()
    // 手机端设置
    if (this.screenWidth < 1025) {
      this.serverGroupSpan = 8
      this.serverTableSpan = 16
    }
    if (this.screenWidth < 640) {
      this.serverGroupSpan = 24
      this.serverTableSpan = 24
    }
  },
  methods: {
    getTenants () {
      getAllTenants().then(res => {
        let tenants = []
        const result = res.data
        for (let i in result) {
          tenants.push({
            key: result[i].id,
            label: result[i].name
          })
        }
        this.tenantList = tenants
      })
    },
    ruleChange (key, rule) {
      this.conditionObjects[key]['value'] = ''
      this.conditionObjects = JSON.parse(JSON.stringify(this.conditionObjects))
    },
    showDeleteChange () {
      this.getServers()
    },
    tagClick () {
      this.searchConditionModifyOpen()
    },
    handleAdd () {
      this.searchConditionModifyOpen()
    },
    handleClose (event, name) {
      // delete this.conditionObjects[name]
      // Vue.delete 可以触发视图更新, delete不会
      Vue.delete(this.conditionObjects, name)
      // 同时要删掉checkBox 勾选状态
      this.condition = Object.keys(this.conditionObjects)
      this.conditionSearch()
    },
    remoteMethodServer (query) {
      if (query !== '') {
        this.loadingServer = true
        console.log(query)
        this.allServersRemote = this.allServers.filter(item => item.toLowerCase().indexOf(query.toLowerCase()) > -1)
        this.loadingServer = false
      } else {
        this.allServersRemote = []
      }
    },
    remoteMethodInnerIp () {
      if (query !== '') {
        this.allInnerIpRemote = this.allInnerIp.filter(item => item.toLowerCase().indexOf(query.toLowerCase()) > -1)
      } else {
        this.allInnerIpRemote = []
      }
    },
    remoteMethodPublicIp () {
      if (query !== '') {
        this.allPublicIpRemote = this.allPublicIp.filter(item => item.toLowerCase().indexOf(query.toLowerCase()) > -1)
      } else {
        this.allPublicIpRemote = []
      }
    },
    dealShowName (value, key, rule) {
      if (value) {
        if (rule === 'equal') {
          if (key === '操作系统') {
            return this.osList.filter(item => item.value === parseInt(value)).map(item => item.label)[0]
          } else if (key === '服务商') {
            return this.allSupportList.filter(item => value.indexOf(item.id) > -1).map(item => item.name).join(',')
          } else if (key === '主机名' || key === '私有IP' || key === '公网IP') {
            return value.join(',')
          } else {
            return value
          }
        } else {
          return value
        }
      } else {
        return ''
      }
    },
    dealValue (item, key) {
      // contain  equal  no_equal
      if (item) {
        if (item['rule'] === 'equal') {
          if (key === '主机名' || key === '服务商' || key === '私有IP' || key === '公网IP') {
            return item['value'].join(',')
          } else {
            return item['value']
          }
        } else if (item['rule'] === 'contain') {
          return item['value']
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    searchConditionModifyOpen () {
      this.searchConditionModal = true
    },
    search () {
      this.searchConditionModal = false
      this.conditionSearch()
    },
    conditionSearch () {
      // 触发日志查询方法
      let obj = this.conditionObjects
      this.searchForm.hostname = this.dealValue(obj['主机名'], '主机名')
      this.searchForm.server_id = this.dealValue(obj['主机ID'], '主机ID')
      this.searchForm.name = this.dealValue(obj['别名'], '别名')
      this.searchForm.inner_ip = this.dealValue(obj['私有IP'], '私有IP')
      this.searchForm.public_ip = this.dealValue(obj['公网IP'], '公网IP')
      this.searchForm.support = this.dealValue(obj['服务商'], '服务商')
      this.searchForm.region = this.dealValue(obj['地域'], '地域')
      this.searchForm.os = this.dealValue(obj['操作系统'], '操作系统')
      this.searchForm.rules = {
        hostname: '主机名' in obj ? obj['主机名']['rule'] : '',
        inner_ip: '私有IP' in obj ? obj['私有IP']['rule'] : '',
        public_ip: '公网IP' in obj ? obj['公网IP']['rule'] : '',
        support: '服务商' in obj ? obj['服务商']['rule'] : ''
      }

      this.getServers()
    },
    searchConditionClear () {
      this.condition = []
      this.conditionChange([])
    },
    conditionChange (conditions) {
      let mConditions = JSON.parse(JSON.stringify(conditions))
      let conditionObjects = JSON.parse(JSON.stringify(this.conditionObjects))
      for (let i in conditionObjects) {
        let idx = mConditions.indexOf(i)
        if (idx > -1) {
          mConditions.splice(idx, 1)
        } else {
          delete (this.conditionObjects[i])
        }
      }
      for (let i in mConditions) {
        this.conditionObjects[mConditions[i]] = {
          rule: 'contain',
          value: ''
        }
      }
    },
    selectChange (selection) {
      this.tableDataSel = selection
    },
    sortChange (params) {
      if (params.order === 'asc') {
        this.searchForm.ordering = params.key
      } else if (params.order === 'desc') {
        this.searchForm.ordering = '-' + params.key
      } else {
        this.searchForm.ordering = ''
      }
      this.getServers()
    },
    onSelectOs (value) {
      if (value === 0) {
        this.winrmVisible = false
        this.serverForm.winrm_port = null
      } else if (value === 1) {
        this.winrmVisible = true
        this.serverForm.winrm_port = 5986
      }
    },
    pollData () {
      this.polling = setInterval(() => {
        this.getScanHostList()
      }, 60000)
    },
    handleTabClick (value) {
      if (value === 'scanIP') {
      } else if (value === 'scanHostName') {
        // 获取所有已经绑定凭证并且 要获取主机名的机器
        this.countScanHostNameSel = 0
        this.scanHostNameForm.hosts = []
        this.tableDataScanHostNameSel = []
        this.getAllScanServers()
      }
    },
    drawerClose () {
      let that = this.scanForm
      that.network = ''
      that.hosts = []
      this.tableDataScan = []
      this.tableDataScanSel = []
      this.countScanSel = 0
      this.countScan = 0
    },
    handleScan () {
      this.drawerClose()
      this.defaultScanIndex = 'scanIP'
      this.scanModal = true
    },
    selectChangeScan (selection) {
      this.tableDataScanSel = selection
      this.countScanSel = this.tableDataScanSel.length
      this.scanForm.hosts = this.tableDataScanSel
      // this.$emit('on-result-change', this.tableDataSel)
    },
    selectChangeScanHostName (selection) {
      this.tableDataScanHostNameSel = selection
      this.countScanHostNameSel = this.tableDataScanHostNameSel.length
      this.scanHostNameForm.hosts = this.tableDataScanHostNameSel.map(item => item.id)
      // this.$emit('on-result-change', this.tableDataSel)
    },
    // 初始化页面按钮权限（增删改查操作权限）
    initOperatePerm () {
      let permissions = this.$store.state.user.permissions
      if (permissions.indexOf('add_server') > -1) {
        this.isServerAdd = true
      } else {
        this.isServerAdd = false
      }
      if (permissions.indexOf('change_server') > -1) {
        this.isServerEdit = true
      } else {
        this.isServerEdit = false
      }
      if (permissions.indexOf('delete_server') > -1) {
        this.isServerDelete = true
      } else {
        this.isServerDelete = false
      }
      if (permissions.indexOf('view_server') > -1) {
        this.isServerView = true
      } else {
        this.isServerView = false
      }
    },
    ServerGroupShowBtn (status) {
      this.ServerGroupIsShow = status
      if (status) {
        if (this.screenWidth < 1025) {
          this.serverGroupSpan = 8
          this.serverTableSpan = 16
        } else {
          this.serverGroupSpan = 5
          this.serverTableSpan = 19
        }
      } else {
        this.serverGroupSpan = 1
        this.serverTableSpan = 23
      }
    },
    getServers (value = 1, loadingShow = true) {
      this.page = value
      if (loadingShow) {
        this.table_loading = true
      }
      if (!this.deleteFlag) {
        this.searchForm['is_delete'] = this.deleteFlag
      } else {
        this.searchForm['is_delete'] = null
      }
      this.searchForm['size'] = this.size
      this.searchForm['page'] = this.page
      getOpsCenterServer(this.searchForm).then(res => {
        let result = res.data
        let tableData = result.results
        this.count = result.count
        this.tableData = tableData
        this.table_loading = false
      }).catch(res => {
        this.table_loading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取主机列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    getAllServers () {
      getOpsCenterAllServer().then(res => {
        let result = res.data
        this.no_select_server = []
        this.allServers = []
        this.allInnerIp = []
        this.allPublicIp = []
        for (let i in result) {
          this.no_select_server.push({
            key: result[i].id,
            label: `${result[i].hostname} (${result[i].public_ip} / ${result[i].inner_ip})`
          })
          if (result[i].hostname) {
            this.allServers.push(result[i].hostname)
          }
          if (result[i].inner_ip) {
            this.allInnerIp.push(result[i].inner_ip)
          }
          if (result[i].public_ip) {
            this.allPublicIp.push(result[i].public_ip)
          }
        }
      })
    },
    getAllScanServers () {
      getOpsCenterAllScanServer().then(res => {
        let result = res.data
        this.tableDataScanHostName = result
        this.countScanHostName = result.length
      })
    },
    getServerGroup () {
      getOpsCenterServerGroup().then(res => {
        this.zNodes = this.zNodes.concat(res.data)
        this.zTreeInit()
      }).catch(res => {
        if (res.request) {
          that.$Notice.error({
            title: '获取主机组失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    changeServerSubmit () {
      this.$refs['serverForm'].validate((valid) => {
        if (valid) {
          let regxp = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
          if (this.serverForm.inner_ip) {
            if (!regxp.test(this.serverForm.inner_ip)) {
              this.$Notice.error({ title: '私有ip地址格式错误' })
              return false
            }
          }
          if (this.serverForm.public_ip) {
            if (!regxp.test(this.serverForm.public_ip)) {
              this.$Notice.error({ title: '公网ip地址格式错误' })
              return false
            }
          }
          changeOpsCenterServer(this.serverForm, this.serverForm.id).then(res => {
            this.$Notice.success({
              title: '操作成功'
            })
            this.serverChangeModalClose()
            this.getServers(this.page)
            this.getAllServers()
          }).catch(res => {
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            }
          })
        }
      })
    },
    getAllSupport () {
      getOpsCenterAllSupport().then(res => {
        this.allSupportList = res.data
      })
    },
    getAllCertificate () {
      getOpsCenterAllCertificate().then(res => {
        this.allCertificateList = res.data
      })
    },
    searchReset () {
      this.searchForm.hostname = ''
      this.searchForm.server_id = ''
      this.searchForm.name = ''
      this.searchForm.inner_ip = ''
      this.searchForm.public_ip = ''
      this.searchForm.support = ''
      this.searchForm.region = ''
      this.searchForm.os = ''
      this.searchForm.server_info = ''
    },
    changeFormReset () {
      this.serverForm.id = 0
      this.serverForm.hostname = ''
      this.serverForm.server_id = ''
      this.serverForm.name = ''
      this.serverForm.inner_ip = ''
      this.serverForm.public_ip = ''
      this.serverForm.support = ''
      this.serverForm.region = ''
      this.serverForm.os = 0
      this.serverForm.certificate = []
      this.serverForm.server_info = ''
      this.serverForm.manager = ''
      this.serverForm.remark = ''
    },
    zTreeInit () {
      this.zTree = $.fn.zTree.init($('#serverGroupZTree'), this.zTreeSetting, this.zNodes)
    },
    zTreeOnClick (event, treeId, treeNode) {
      if (treeNode.id === 0) {
        this.searchForm.id__in = ''
      } else {
        // let childNodes = this.getChildNodes(treeNode)
        let childNodes = treeNode.server
        if (childNodes) {
          this.searchForm.id__in = childNodes
        } else {
          this.searchForm.id__in = 99999999
        }
      }
      this.getServers()
    },
    getChildNodes (treeNode) {
      let childNodes = this.zTree.transformToArray(treeNode)
      let nodes = []
      for (let i = 0; i < childNodes.length; i++) {
        if (childNodes[i].server) {
          nodes = nodes.concat(childNodes[i].server.split(','))
        }
      }
      return nodes.join(',')
    },
    OnRightClick (event, treeId, treeNode) {
      if (!treeNode && event.target.tagName.toLowerCase() !== 'button' && $(event.target).parents('a').length === 0) {
        this.zTree.cancelSelectedNode()
        this.showRMenu('root', event.clientX, event.clientY)
      } else if (treeNode && !treeNode.noR) {
        this.zTree.selectNode(treeNode)
        this.showRMenu('node', event.clientX, event.clientY)
      }
    },
    showRMenu (type, x, y) {
      $('#rMenu ul').show()
      $('#rMenu').css({ 'top': y - 60 + 'px', 'left': x - 250 + 'px', 'visibility': 'visible' })
      $('body').bind('mousedown', this.onBodyMouseDown)
    },
    hideRMenu () {
      if ($('#rMenu')) $('#rMenu').css({ 'visibility': 'hidden' })
      $('body').unbind('mousedown', this.onBodyMouseDown)
    },
    onBodyMouseDown (event) {
      if (!(event.target.id === 'rMenu' || $(event.target).parents('#rMenu').length > 0)) {
        $('#rMenu').css({ 'visibility': 'hidden' })
      }
    },
    expand () {
      this.hideRMenu()
      let selectNodes = this.zTree.getSelectedNodes()
      this.zTree.expandNode(selectNodes[0], true, null, null)
    },
    expandSon () {
      this.hideRMenu()
      let selectNodes = this.zTree.getSelectedNodes()
      this.zTree.expandNode(selectNodes[0], true, true, null)
    },
    collapse () {
      this.hideRMenu()
      let selectNodes = this.zTree.getSelectedNodes()
      this.zTree.expandNode(selectNodes[0], false, null, null)
    },
    collapseAll () {
      this.hideRMenu()
      this.zTree.expandAll(false)
    },
    openAll () {
      this.hideRMenu()
      this.zTree.expandAll(true)
    },
    addHoverDom (treeId, treeNode) {
      let that = this
      let sObj = $('#' + treeNode.tId + '_span')
      if (treeNode.editNameFlag || $('#addBtn_' + treeNode.tId).length > 0) return
      let addStr = "<span class='button add' id='addBtn_" + treeNode.tId + "' title='add node' onfocus='this.blur();'></span>"
      sObj.after(addStr)
      let btn = $('#addBtn_' + treeNode.tId)
      if (btn) {
        btn.bind('click', function () {
          let newName = '新分组' + (that.newCount++)
          let reqData = { 'name': newName, 'parent_id': treeNode.id }
          changeOpsCenterServerGroup(reqData).then(res => {
            let result = res.data
            let zTree = $.fn.zTree.getZTreeObj('serverGroupZTree')
            zTree.addNodes(treeNode, { id: result['id'], pId: result['parent_id'], name: result['name'] })
          }).catch(res => {
            if (res.request) {
              that.$Notice.error({
                title: '添加主机组失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            }
          })
        })
      }
    },
    removeHoverDom (treeId, treeNode) {
      $('#addBtn_' + treeNode.tId).unbind().remove()
    },
    showRemoveBtn (treeId, treeNode) {
      return !treeNode.id === 0
    },
    showRenameBtn (treeId, treeNode) {
      return !treeNode.id === 0
    },
    beforeRemove (treeId, treeNode) {
      if (treeNode.id === 0) {
        this.$Notice.error({
          title: '此分组不可删除'
        })
        return false
      }
      let zTree = $.fn.zTree.getZTreeObj('serverGroupZTree')
      zTree.selectNode(treeNode)
      return confirm('确认删除「' + treeNode.name + '」分组吗？')
    },
    onRemove (e, treeId, treeNode) {
      deleteOpsCenterServerGroup(treeNode.id).then(res => {
        that.$Notice.success({
          title: '删除成功！'
        })
      }).catch(res => {
        if (res.request) {
          that.$Notice.error({
            title: '删除失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    beforeRename (treeId, treeNode, newName) {
      if (newName.length === 0) {
        that.$Notice.error({
          title: '节点名称不能为空'
        })
        return false
      }
      return true
    },
    beforeDrag (treeId, treeNodes) {
      return false
    },
    onRename (e, treeId, treeNode, isCancel) {
      if (treeNode.id === 0) {
        this.$Notice.error({
          title: '此分组不可编辑'
        })
        return false
      }
      let reqData = { 'name': treeNode.name }
      changeOpsCenterServerGroup(reqData, treeNode.id).then(res => {
        this.$Notice.success({
          title: '操作成功！'
        })
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    editServerBtn () {
      let selectNodes = this.zTree.getSelectedNodes()
      if (selectNodes[0]['id'] === 0) {
        this.$Notice.error({
          title: '此分组不可编辑'
        })
        return false
      }
      this.hideRMenu()
      this.editServerModalTitle = '「' + selectNodes[0]['name'] + '」绑定主机'
      this.editServerModal = true
      this.editServerForm.id = selectNodes[0]['id']
      this.editServerForm.name = selectNodes[0]['name']
      this.editServerForm.server = selectNodes[0]['server_list']
      this.editServerForm.parent_id = selectNodes[0]['parent_id']
    },
    editServerForGroupSubmit () {
      let reqData = {
        id: this.editServerForm.id,
        name: this.editServerForm.name,
        server: this.editServerForm.server.join(','),
        parent_id: this.editServerForm.parent_id
      }
      changeOpsCenterServerGroup(reqData, this.editServerForm.id).then(res => {
        this.editServerModal = false
        this.editServerModalCancel()
        this.zNodes = [{ 'id': 0, 'parent_id': 0, 'name': '所有主机', 'open': 'true' }]
        this.getServerGroup()
        this.searchForm.id__in = ''
        this.getServers()
        this.$Notice.success({
          title: '操作成功！'
        })
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    editServerModalCancel () {
      this.editServerForm.id = 0
      this.editServerForm.name = ''
      this.editServerForm.server = []
      this.editServerForm.parent_id = 0
    },
    editServerChange (newKeyList) {
      this.editServerForm.server = newKeyList
    },
    serverChangeModalClose () {
      this.serverChangeModal = false
      this.changeFormReset()
    },
    serverChangeModifyModalOpen (params) {
      this.selectRow = params.row
      if (this.selectRow) {
        this.serverForm.id = this.selectRow.id
        this.serverForm.hostname = this.selectRow.hostname
        this.serverForm.server_id = this.selectRow.server_id
        this.serverForm.name = this.selectRow.name
        this.serverForm.inner_ip = this.selectRow.inner_ip
        this.serverForm.public_ip = this.selectRow.public_ip
        this.serverForm.region = this.selectRow.region
        this.serverForm.os = this.selectRow.os
        this.serverForm.winrm_port = this.selectRow.winrm_port
        this.serverForm.tenant_id = this.selectRow.tenant_id
        if (this.selectRow.support) {
          this.serverForm.support = this.selectRow.support.id
        }
        if (this.selectRow.certificate) {
          this.serverForm.certificate = this.selectRow.certificate.map(item => item.id)
        }
        this.serverForm.server_info = this.selectRow.server_info
        this.serverForm.manager = this.selectRow.manager
        this.serverForm.remark = this.selectRow.remark
        this.serverChangeModalTitle = '编辑主机：' + this.selectRow.server_id
        this.serverChangeModal = true
      } else {
        this.$Notice.error({
          title: '请选择一台主机'
        })
      }
    },
    rowClick (data, index) {
      let oldStatus = this.tableData[index].checkBox
      this.tableData.forEach((items) => {
        this.$set(items, 'checkBox', false)
      })
      this.tableData[index].checkBox = !oldStatus
      if (this.tableData[index].checkBox) {
        this.selectRow = data
      } else {
        this.selectRow = ''
      }
    },
    serverRemove () {
      let delHost = this.tableDataSel.map(item => item.hostname)
      this.$Modal.confirm({
        title: '删除',
        content: '确定要删除主机「' + delHost.join(',') + '」吗?',
        onOk: () => {
          for (let i in this.tableDataSel) {
            this.selectRow = this.tableDataSel[i]
            try {
              if (this.selectRow) {
                this.selectRow['is_delete'] = true
                if (!this.selectRow.hostname) {
                  this.selectRow.hostname = '未知'
                }
                if (this.selectRow.support) {
                  this.selectRow.support = this.selectRow.support.id
                }
                if (this.selectRow.certificate) {
                  this.selectRow.certificate = this.selectRow.certificate.map(item => item.id)
                }
                changeOpsCenterServer(this.selectRow, this.selectRow.id).then(res => {
                  this.getServers()
                }).catch(res => {
                  if (res.request) {
                    // that.$Notice.error({
                    //   title: '删除失败！请求状态码:' + res.request.status,
                    //   desc: res.request.responseText
                    // })
                  }
                })
              }
            } catch (e) {
              console.log(e)
            }
          }
          this.$Notice.success({
            title: '删除成功！'
          })
        }
      })
    },
    getRegionList () {
      getRegion().then(res => {
        let result = res.data
        this.allRegionList = result.result
      })
    },
    supportChange (select) {
      let type = 4
      for (let i in this.allSupportList) {
        if (this.allSupportList[i].id === select) {
          type = this.allSupportList[i].type
          break
        }
      }
      this.regionList = []
      this.collectForm.region = ''
      if (type === 1) {
        this.regionList = this.allRegionList.aliyun_region_list
      } else if (type === 2) {
        this.regionList = this.allRegionList.ucloud_region_list
      } else if (type === 3) {
        this.regionList = this.allRegionList.aws_region_list
      } else if (type === 8) {
        this.regionList = this.allRegionList.huawei_region_list
      }
    },
    collectSubmit () {
      this.collectServerLoading = true
      collectServer(this.collectForm).then(res => {
        let result = res.data
        if (result.code === 200) {
          this.$Notice.success({
            title: '收集成功',
            desc: result.data
          })
          this.collectModal = false
          this.getServers()
        } else {
          this.$Notice.error({
            title: '收集失败！失败状态码:' + result.code,
            desc: result.msg
          })
        }
        this.collectServerLoading = false
      }).catch(res => {
        this.collectServerLoading = false
        if (res.request) {
          this.$Notice.error({
            title: '收集失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    getScanHostList () {
      let params = {
        search: this.uid
      }
      getAllScanTmp(params).then(res => {
        this.tableDataScan = res.data
        this.countScan = res.data.length
        this.countScanSel = 0
        let result = res.data.filter(item => item.os === 9)
        if (!result.length) {
          clearInterval(this.polling)
          this.scanServerLoading = false
          this.scanServerOkDisabled = false
        }
      })
    },
    scanSubmit (name) {
      if (this.scanForm.network !== '') {
        this.scanServerLoading = true
        scanServer(this.scanForm).then(res => {
          let result = res.data
          if (result.code === 200) {
            this.uid = result.data
            this.pollData()
            // this.getScanHostList()
            // this.countScan = result.data.length
            // this.tableDataScan = result.data.map((value, index, array) => {
            //   return { 'inner_ip': value }
            // })
          } else {
            this.$Notice.error({
              title: '扫描失败！失败状态码:' + result.code,
              desc: result.msg
            })
          }
          // this.scanServerLoading = false
        }).catch(res => {
          this.scanServerLoading = false
          if (res.request) {
            this.$Notice.error({
              title: '收集失败！请求状态码:' + res.request.status,
              desc: res.request.responseText
            })
          }
        })
      } else {
        this.$Notice.error({ title: '扫描网段/ip不能为空 ！' })
      }
    },
    // 导入选中的主机
    scanConfirmSubmit (name) {
      if (this.scanForm.hosts.length !== 0) {
        this.scanServerOkLoading = true
        scanServerOk(this.scanForm).then(res => {
          let result = res.data
          if (result.code === 200) {
            this.$Notice.success({
              title: '导入成功',
              desc: result.data
            })
            this.scanModal = false
            this.getServers()
          } else {
            this.$Notice.error({
              title: '导入失败！失败状态码:' + result.code,
              desc: result.msg
            })
          }
          this.scanServerOkLoading = false
        }).catch(res => {
          this.scanServerOkLoading = false
          if (res.request) {
            this.$Notice.error({
              title: '收集失败！请求状态码:' + res.request.status,
              desc: res.request.responseText
            })
          }
        })
      } else {
        this.$Notice.error({ title: '至少选择一个主机进行导入 ！' })
      }
    },
    scanHostNameSubmit () {
      if (this.scanHostNameForm.hosts.length !== 0) {
        this.scanHostNameLoading = true
        scanHostName(this.scanHostNameForm).then(res => {
          let result = res.data
          if (result.code === 200) {
            this.$Notice.success({
              title: '扫描成功',
              desc: result.data
            })
            this.scanModal = false
            this.getServers()
          } else {
            this.$Notice.error({
              title: '扫描失败！失败状态码:' + result.code,
              desc: result.msg
            })
          }
          this.scanHostNameLoading = false
        }).catch(res => {
          this.scanHostNameLoading = false
          if (res.request) {
            this.$Notice.error({
              title: '收集失败！请求状态码:' + res.request.status,
              desc: res.request.responseText
            })
          }
        })
      } else {
        this.$Notice.error({ title: '至少选择一个主机获取主机名 ！' })
      }
    },
    getNowTime (type) {
      let date = new Date()
      let year = date.getFullYear()
      let month = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
      let day = date.getDate()
      let hour = date.getHours() + ':'
      let minute = date.getMinutes() + ':'
      let second = date.getSeconds()
      let nowTime = year + '-' + month + '-' + day
      if (type !== 'date') {
        nowTime += ' ' + hour + minute + second
      }
      return nowTime
    },
    daysBetween (sDate1) {
      let time1 = Date.parse(new Date(sDate1))
      let time2 = Date.parse(new Date(this.getNowTime('date')))
      let nDays = parseInt((time1 - time2) / 1000 / 3600 / 24)
      if (time1 > time2) {
        return nDays
      } else {
        return -nDays
      }
    },
    // 监控自动刷新
    setTimer () {
      if (this.timer == null) {
        this.timer = setInterval(() => {
          this.getServers(this.page, false)
        }, 60000)
      }
    },
    // 定时刷新控制器
    controlMonitorTimer () {
      // this.monitorModal = !this.monitorModal
      if (this.monitorModal) {
        this.setTimer()
      } else {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    connetRemoteAsset (ip) {
      // 调用后台创建 guacamole connect ，将返回id直接传到下面url中，连接远程机器，无需管 ops和 guacamole数据同步，目的是连接远程机器，权限在ops这边控制
      // let name = this.systemUsersSel
      let data = {
        ip: ip,
        username: this.systemUsersSel,
        key: this.systemUserKeySel,
        os: this.conHostOs,
        keyType: this.conProtocolType
      }
      getConnectId(data).then(res => {
        if (res.status === 200) {
          let connectId = ClientIdentifier(parseInt(res.data))
          // window.location.href = 'http://opsdeep.aukeyit.com/guacamole/#/client/' + connectId
          // let url = 'http://10.1.2.127:8080/guacamole/#/client/' + connectId
          let url = guacamoleUrl + '/guacamole/#/client/' + connectId
          let h = window.screen.availHeight
          let w = window.screen.availWidth
          window.open(url, '堡垒机', 'left=0,top=0,width=' + w + ',height=' + h + ',directories=no,location=no,toolbar=no,menubar=no,status=no,scrollbars=no,titlebar=no,resizable=no')
        } else {
          this.$Message.error('获取连接信息失败，请核查数据')
        }
      })
    },
    // 远程连接
    handleConnect (params) {
      // 先判断用户是否有权限连接当前这台主机if (this.$store.state.user.superuser) {
      // let paramsPerm = {
      //   username: this.$store.state.user.userName
      // }
      this.conHostOs = params.row.os
      getUserHostPerm().then(res => {
        let canCon
        this.userPermDetail = res.data.map(item => item[0])
        let sysUsers = res.data.filter(item => item[0] === params.row.id)
        if (this.$store.state.user.superuser) {
          if (this.userPermDetail.indexOf(params.row.id) > -1) {
            canCon = true
          } else {
            canCon = false
            this.$Modal.error({
              title: '主机未绑定凭证',
              content: '该主机未绑定任何凭证，请先绑定凭证然后再连接 ！'
            })
          }
        } else {
          if (this.userPermDetail.indexOf(params.row.id) > -1) {
            canCon = true
          } else {
            canCon = false
            this.$Modal.error({
              title: '无操作权限',
              content: '您没有该主机的连接权限，请联系管理员开通 ！'
            })
          }
        }
        if (!canCon) {
        } else {
          // 弹出系统用户选择框
          if (sysUsers) {
            this.systemUsersAll = sysUsers.map(item => item[1])
            this.systemUsersSel = this.systemUsersAll[0]
            this.systemUserKeySel = sysUsers.filter(item => item[1] === this.systemUsersSel).map(item => item[2])[0]
            this.conProtocolType = sysUsers.filter(item => item[1] === this.systemUsersSel).map(item => item[3])[0]
          } else {
            this.$Message.error('系统异常，取不到当前用户，当前主机所对应的系统用户，请检查权限数据')
          }
          // 判断公网ip 私有ip 给defaultIp 赋值
          if (params.row.public_ip || params.row.inner_ip) {
            this.defaultIp = params.row.public_ip ? 'public' : 'private'
            this.defaultSelIp = params.row.public_ip ? params.row.public_ip : params.row.inner_ip
          } else {
            this.$Message.error('系统异常，公有IP,私有IP都为空,请检查凭证ip数据')
            return
          }
          this.$Modal.confirm({
            width: '500px',
            title: '远程连接',
            onOk: () => {
              if (this.defaultSelIp) {
                this.connetRemoteAsset(this.defaultSelIp)
              } else {
                this.$Message.error('ip为空，不能建立连接,请检查凭证ip数据')
              }
            },
            render: (h) => {
              return h('div', [
                h('Divider'),
                h('span', { style: { color: '#515a6e' } }, '连接IP：'),
                h('RadioGroup', {
                  props: {
                    type: 'button',
                    value: this.defaultIp
                  },
                  style: { marginLeft: '58px' },
                  on: {
                    'on-change': (val) => {
                      if (val === 'private') {
                        this.defaultSelIp = ''
                        if (params.row.inner_ip) {
                          this.defaultSelIp = params.row.inner_ip
                        } else {
                          this.$Message.error('内部ip为空，不能建立连接')
                        }
                      } else {
                        this.defaultSelIp = ''
                        if (params.row.public_ip) {
                          this.defaultSelIp = params.row.public_ip
                        } else {
                          this.$Message.error('外部ip为空，不能建立连接')
                        }
                      }
                    }
                  }
                }, [
                  h('Radio', {
                    props: {
                      label: 'private'
                    } }, '内部IP'),
                  h('Radio', {
                    props: {
                      label: 'public'
                    } }, '外部IP')
                ]),
                h('br'),
                h('br'),
                h('span', { style: { color: '#515a6e' } }, '请选择凭证用户：'),
                h('Select', {
                  props: {
                    value: this.systemUsersSel
                  },
                  on: {
                    'on-change': (value) => {
                      this.systemUsersSel = value
                      this.systemUserKeySel = sysUsers.filter(item => item[1] === this.systemUsersSel).map(item => item[2])[0]
                    }
                  },
                  style: {
                    width: '200px'
                  }
                },
                this.systemUsersAll.map(function (item) {
                  return h('Option', {
                    props: { value: item }
                  }, item)
                })
                ),
                h('Divider')
              ])
            }
          })
        }
      })
    },
    getTableColumns () {
      let data = [this.tableColumnList.selection]
      this.col.forEach(col => data.push(this.tableColumnList[col]))
      data.push(this.tableColumnList.action)
      this.columns = data
    },
    getShowCol () {
      getServerTableCol().then(res => {
        let result = res.data
        let keys = []
        if (result.length) {
          for (let col in result) {
            let colName = Object.keys(result[col])[0]
            if (result[col][colName]) {
              keys.push(colName)
            }
          }
        } else {
          for (let columnName in this.tableColumnList) {
            if (columnName !== 'selection' && columnName !== 'action') {
              keys.push(columnName)
            }
          }
        }
        this.col = keys
        this.getTableColumns()
      })
    },
    showColConfig () {
      this.tableColModal = true
    },
    saveShowColConfig () {
      this.saveShowColConfiging = true
      let reqData = {
        col: []
      }
      for (let columnName in this.tableColumnList) {
        if (columnName !== 'selection' && columnName !== 'action') {
          if (this.tableColumnList.hasOwnProperty(columnName)) {
            if (this.col.indexOf(columnName) > -1) {
              reqData.col.push({ [columnName]: true })
            } else {
              reqData.col.push({ [columnName]: false })
            }
          }
        }
      }
      postServerTableCol(reqData).then(res => {
        this.$Notice.success({
          title: '保存成功'
        })
        this.tableColModal = false
        this.saveShowColConfiging = false
        this.getShowCol()
      }).catch(err0 => {
        this.saveShowColConfiging = false
        console.log(err0)
        if (err0.request) {
          this.$Notice.error({
            title: err0.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '保存失败'
          })
        }
      })
    },
    pageSizeChange (size) {
      this.size = size
      this.getServers(this.page)
    }
  },
  beforeDestroy () {
    clearInterval(this.polling)
    clearInterval(this.timer)
    this.timer = null
  },
  created: function () {
    clearInterval(this.timer)
    this.timer = null
    this.getShowCol()
  }
  // destroyed () {
  //   let zTree = $.fn.zTree.getZTreeObj('serverGroupZTree')
  //   zTree.refresh()
  // }
}
</script>

<style lang="scss">
  @import '../../plugin/ztree/css/metroStyle/metroStyle.css';
  #rMenu {
    position:absolute;
    visibility:hidden;
    top:0;
    background-color: #555;
    text-align: left;
    padding: 2px;
  }
  #rMenu a{
    padding: 3px 15px 3px 15px;
    cursor: pointer;
    list-style: none outside none;
  }
  .list-group-item {
    position: relative;
    display: block;
    padding: 10px 15px;
    margin-bottom: -1px;
    background-color: #fff;
    border: 1px solid #ddd;
  }

  @media screen and (min-width:768px){
    .tree-style{
      .ivu-row{
        padding-left: 0!important;
        padding-top:0!important;
        padding-bottom: 0!important;
      }
    }
  }
  .tree-style{
    .ztree *{
      font-size:14px;
    }
    .ztree li span.button.ico_open,
    .ztree li span.button.ico_close,
    .ztree li span.button.ico_docu
    {
      display: none;
    }
    .ztree li span.button.root_close {
      background-position: -126px -65px;
    }
    .ztree li span.button.root_open {
      background-position: -105px -65px;
    }
    .ztree li span.button.center_close{
      background-position: -126px -23px;
    }
    .ztree li span.button.bottom_close {
      background-position: -126px -45px;
    }
    .ztree li span.button.bottom_open {
      background-position: -105px -45px;
    }
    .ztree li span.button.center_open {
      background-position: -105px -23px;
    }
    .ivu-col-span-1,.ivu-col-span-5{
      padding-top:16px;
      padding-bottom:10px;
    }
    .ivu-col-span-5{
      border-right: 6px solid #f5f7f9;
      margin-right:-6px;
      width: 18%;
    }
    .ivu-col-span-23{
      padding-top:16px!important;
    }
    .ztree li{
      line-height: 29px;
      ul{
        padding:0;
        li{
          padding:0 0 0 12px;
        }
      }
      a{
        height: 29px;
        width:65%;
        span.button{
          margin-top:7px;
        }
        &.curSelectedNode{
          background:none;
          color:#2d8cf0;
          span.button{
            display: none;
          }
          &:hover{
              span.button.add,
              span.button.edit,
              span.button.remove{
              display: inline-block;
            }
          }
        }
      }
    }
    .ztree li ul.line{
      background:none;
    }
    .ztree li span.button{
      background-image:url("../../assets/images/metro1.png");
    }
    .ztree li span.button.center_open{
      position: relative;
    }
    .ivu-col-span-19{
      padding-top:16px;
      padding-left: 20px;
      border-left: 6px solid #f5f7f9;
      width: 82%;
    }
  }
</style>
<style lang="scss" scoped>
  @media screen and (max-width:1280px){
    .mob-align-right{
      text-align:right;
      width: 100%;
    }
  }
  @media screen and (max-width:640px){
    .ivu-input-wrapper,.ivu-select{
      min-width: initial!important;
    }
    .scanBtn{
      margin-top:5px;
    }
  }
</style>
